import { render, staticRenderFns } from "./ComboItem.vue?vue&type=template&id=2746690c&scoped=true&"
import script from "./ComboItem.vue?vue&type=script&lang=js&"
export * from "./ComboItem.vue?vue&type=script&lang=js&"
import style0 from "./ComboItem.vue?vue&type=style&index=0&id=2746690c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2746690c",
  null
  
)

export default component.exports